import script from "./ActivityDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./ActivityDetailPage.vue?vue&type=style&index=0&id=bb557474&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb557474"]])

export default __exports__